import React from 'react';

/**
 * RateQuote Component
 * Renders radio buttons for selecting if a rate quote is needed.
 * Props:
 *  - state: form state object
 *  - handleChange: input change handler
 */
const RateQuote = ({ state, handleChange }) => {
  return (
    <div className="row mt-3">
      {/* Section title */}
      <div className="col-12">
        <p>Need Rate Quote</p>
      </div>

      {/* Radio buttons for selecting "Yes" or "No" */}
      <div className="col-3 d-flex gap-5 align-items-center">
        {/* Radio option: No */}
        <div className="radio me-5">
          <input
            id="No"
            type="radio"
            name="rateQuote"
            value="No"
            checked={state.rateQuote === "No"} // Checked if state value is "No"
            onChange={handleChange}         // Calls handler on change
            autoComplete='off'
          />
          <label htmlFor="No">No</label>
        </div>

        {/* Radio option: Yes */}
        <div className="radio">
          <input
            id="Yes"
            type="radio"
            name="rateQuote"
            value="Yes"
            checked={state.rateQuote === "Yes"} // Checked if state value is "Yes"
            onChange={handleChange}             // Calls handler on change
            autoComplete='off'
          />
          <label htmlFor="Yes">Yes</label>
        </div>
      </div>
    </div>
  );
};

export default RateQuote;
